import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

export default function CampaignStatesDir () {
  return {
    restrict: 'E',
    replace: true,
    template: require('./campaign-states.jade')(jadeLocals),
    scope: {
      campaign: '&',
      copyright: '&',
      state: '='
    },
    link: (scope) => {
      scope.state = 'loading';
      scope.$watch(() => scope.campaign(), () => {

        if (scope.copyright() === true) {
          scope.state = 'copyright';
          return;
        }

        if (scope.campaign() == null) {
          scope.state = 'loading';
          return;
        }

        if (scope.campaign().is_closed === true) {
          scope.state = 'ended';
          return;
        }

        if (scope.campaign().is_pending === true) {
          scope.state = 'pending';
          return;
        }

        if (Array.isArray(scope.campaign().products) && scope.campaign().products.length === 0) {
          scope.state = 'empty-campaign';
          return;
        }

        scope.state = 'ready';

      });
    }
  }
};



// WEBPACK FOOTER //
// ./source/client/pages/store/campaign-states/campaign-states.dir.js